<template>
    <span v-if="!fieldValid">{{ $t('errors.Required', { f: $t(fieldName) }) }}</span>
</template>
<script>
export default {
    components: {},

    props: {
        fieldName: { required: true },
        fieldValid: { required: true },
    },
};
</script>
